(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoitzi-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const home = document.querySelector('.yoitzi-home--motion');

    if (!home || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const revealItems = home.querySelectorAll(
      [
        '.yoitzi-section__header',
        '.yoitzi-apparel',
        '.yoitzi-found',
        '.yoitzi-newsletter',
        '.yoitzi-mood-card',
        '.yoitzi-product-card',
        '.yoitzi-edit-card',
        '.yoitzi-trust-grid > div',
        '.yoitzi-story-card',
      ].join(',')
    );

    revealItems.forEach((item, index) => {
      item.classList.add('yoitzi-reveal');
      item.style.setProperty('--yoitzi-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
    });

    home.classList.add('yoitzi-motion-ready');

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.16,
      }
    );

    revealItems.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoitzi-journal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.YoitziJournalActions) return;
    window.YoitziJournalActions = true;

    const storageKey = 'yoitzi-journal-preferences';
    let toastTimer;

    const readPreferences = () => {
      try {
        const value = JSON.parse(window.localStorage.getItem(storageKey) || '{}');
        return {
          liked: Array.isArray(value.liked) ? value.liked : [],
          saved: Array.isArray(value.saved) ? value.saved : [],
        };
      } catch (_error) {
        return { liked: [], saved: [] };
      }
    };

    const writePreferences = (preferences) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(preferences));
      } catch (_error) {
        // The controls still work for the current page when storage is unavailable.
      }
    };

    const absoluteUrl = (value) => new URL(value, window.location.origin).href;

    const showToast = (message) => {
      const toast = document.querySelector('[data-journal-toast]');
      if (!toast) return;

      window.clearTimeout(toastTimer);
      toast.textContent = message;
      toast.classList.add('is-visible');
      toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
    };

    const closeMenus = (exception) => {
      document.querySelectorAll('[data-journal-menu]').forEach((menu) => {
        if (menu === exception) return;
        menu.hidden = true;
        const trigger = menu.parentElement.querySelector('[data-journal-action="more"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };

    const syncButtons = () => {
      const preferences = readPreferences();

      document.querySelectorAll('[data-journal-action="like"], [data-journal-action="save"]').forEach((button) => {
        const action = button.dataset.journalAction;
        const collection = action === 'like' ? preferences.liked : preferences.saved;
        const active = collection.includes(button.dataset.journalKey);
        const title = button.dataset.journalTitle || 'this story';
        const icon = button.querySelector('[data-journal-icon]');

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', `${active ? 'Remove' : action === 'like' ? 'Like' : 'Save'} ${title}`);
        if (icon && action === 'like') icon.textContent = active ? '♥' : '♡';
      });
    };

    const togglePreference = (button) => {
      const preferences = readPreferences();
      const action = button.dataset.journalAction;
      const key = button.dataset.journalKey;
      const collectionName = action === 'like' ? 'liked' : 'saved';
      const collection = preferences[collectionName];
      const existingIndex = collection.indexOf(key);
      const isAdding = existingIndex === -1;

      if (isAdding) collection.push(key);
      else collection.splice(existingIndex, 1);

      writePreferences(preferences);
      syncButtons();
      showToast(
        action === 'like'
          ? isAdding
            ? 'Added to your likes.'
            : 'Removed from your likes.'
          : isAdding
            ? 'Story saved in this browser.'
            : 'Story removed from saved.'
      );
    };

    const copyLink = async (value) => {
      const url = absoluteUrl(value);
      let copied = false;

      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard API unavailable');
        await Promise.race([
          navigator.clipboard.writeText(url),
          new Promise((_resolve, reject) => window.setTimeout(() => reject(new Error('Clipboard timeout')), 700)),
        ]);
        copied = true;
      } catch (_clipboardError) {
        const input = document.createElement('textarea');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        try {
          copied = Boolean(document.execCommand?.('copy'));
        } catch (_fallbackError) {
          copied = false;
        }
        input.remove();
      }

      showToast(copied ? 'Link copied.' : 'Open the story to copy its address.');
      return copied;
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('.yoitzi-journal [data-journal-action]');

      if (!button) {
        closeMenus();
        return;
      }

      const action = button.dataset.journalAction;

      if (action === 'more') {
        const menu = button.parentElement.querySelector('[data-journal-menu]');
        const willOpen = menu?.hidden;
        closeMenus(menu);
        if (menu) menu.hidden = !willOpen;
        button.setAttribute('aria-expanded', String(Boolean(willOpen)));
        return;
      }

      if (action === 'like' || action === 'save') {
        togglePreference(button);
        return;
      }

      if (action === 'copy') {
        closeMenus();
        await copyLink(button.dataset.journalUrl);
        return;
      }

      if (action === 'share') {
        const shareData = {
          title: button.dataset.journalTitle,
          url: absoluteUrl(button.dataset.journalUrl),
        };

        if (navigator.share) {
          try {
            await navigator.share(shareData);
          } catch (error) {
            if (error.name !== 'AbortError') await copyLink(button.dataset.journalUrl);
          }
        } else {
          await copyLink(button.dataset.journalUrl);
        }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenus();
    });

    document.addEventListener('shopify:section:load', syncButtons);
    syncButtons();
  })();

  } catch(e) { console.error(e); }
})();
})();
